import React, { useState } from "react";
import { LuEye } from "react-icons/lu";
import OrderDetailsModal from "./OrderDetailsModal";
import { updateOrder } from "./liveOrder.store";

// Helper function to safely convert order ID to string
const getOrderIdString = (id) => {
  if (!id) return "";
  if (typeof id === "string" || typeof id === "number") return String(id);
  if (typeof id === "object" && id.id) return String(id.id);
  if (typeof id === "object") return JSON.stringify(id);
  return String(id);
};

const statusClass = (s) => {
  switch (s) {
    case "pending":
      return "pending";
    case "accepted":
      return "accepted";
    case "declined":
      return "declined";
    case "inProcess":
      return "inprocess";
    case "delivered":
      return "delivered";
    default:
      return "";
  }
};

const orderTypeClass = (ot) => {
  switch (ot) {
    case "dine-in":
      return "dine-in";
    case "takeaway":
      return "takeaway";
    case "delivery":
      return "delivery";
    default:
      return "";
  }
};

export default function OrderCard({ order, onStatusUpdate }) {
  const {
    id,
    customer,
    items,
    total,
    currency,
    status,
    order_type,
    table_number = 0,
  } = order;
  const list = items?.slice(0, 2) || [];
  const [showModal, setShowModal] = useState(false);

  const handleView = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  const handleServe = (e) => {
    e.stopPropagation();
    updateOrder(id, { status: "delivered" });
    if (onStatusUpdate) {
      onStatusUpdate(id, { status: "delivered" });
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalStatusUpdate = (orderId, updates) => {
    updateOrder(orderId, updates);
    if (onStatusUpdate) {
      onStatusUpdate(orderId, updates);
    }
  };

  const isPending = status === "all";

  return (
    <>
      <article
        className={`lo-card ${statusClass(status)}`}
        tabIndex={0}
        aria-label={`Order #${getOrderIdString(id)} ${status}`}
      >
        <div className="lo-card-head">
          <h3 className="lo-card-title">Order #{getOrderIdString(id)}</h3>
          {/* <span className={`lo-badge ${statusClass(status)}`}>{status}</span> */}
          <span className={`lo-badge ${orderTypeClass(order_type)}`}>
            {order_type}
          </span>
        </div>
        <p className="lo-sub">
          {customer?.name
            ? String(customer.name)
            : customer
            ? typeof customer === "object"
              ? customer.name || "—"
              : String(customer)
            : "—"}
        </p>
        {order_type === "dine-in" && (
          <p className="lo-sub">Table Number: {table_number}</p>
        )}

        <ul className="lo-items">
          {list.map((it, idx) => (
            <li key={idx}>
              {it.name}
              {it.qty ? ` ×${it.qty}` : ""}
            </li>
          ))}
          {items.length > 2 && (
            <li className="lo-more">+{items.length - 2} more…</li>
          )}
        </ul>
        <div className="lo-total">
          {currency === "INR" ? "₹" : ""}
          {total}
        </div>

        <div className="lo-card-actions">
          {isPending && (
            <>
              {/* <button
                className="lo-action-btn lo-action-btn--accept"
                onClick={handleAccept}
                disabled={processing}
                aria-label="Accept order"
              >
                <LuCheck size={16} />
                Accept
              </button> */}
              {/* <button
                className="lo-action-btn lo-action-btn--decline"
                onClick={handleDecline}
                disabled={processing}
                aria-label="Decline order"
              >
                <LuX size={16} />
                Decline
              </button> */}
            </>
          )}
          <button
            className="lo-action-btn lo-action-btn--view"
            onClick={handleView}
            aria-label="View order details"
          >
            <LuEye size={16} />
            View
          </button>
          <button
            className="lo-action-btn lo-action-btn--serve"
            onClick={handleServe}
            aria-label="Serve order"
          >
            Serve
          </button>
        </div>
      </article>

      {showModal && (
        <OrderDetailsModal
          order={order}
          isOpen={showModal}
          onClose={handleModalClose}
          onStatusUpdate={handleModalStatusUpdate}
        />
      )}
    </>
  );
}
